<template>
  <div class="virtual-contract-manage-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>注册合同查询</span>
            <div>
              <!-- 批量操作按钮已注释 -->
            </div>
          </div>
          <el-form
            :inline="true"
            :model="searchForm"
            class="search-form text-left"
          >
            <el-form-item>
              <el-input
                v-model="searchForm.companyName"
                placeholder="请输入公司名称"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="searchForm.name"
                placeholder="请输入姓名"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="searchForm.phone"
                placeholder="请输入联系方式"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="searchForm.contractDate"
                type="month"
                placeholder="选择合同月份"
                format="yyyy-MM"
                value-format="yyyy-MM"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch"> 查询 </el-button>
              <el-button @click="handleReset"> 重置 </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>注册合同列表</span>
            <el-button
              type="primary"
              size="small"
              style="float: right"
              @click="handleAdd"
            >
              新增
            </el-button>
          </div>
          <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="companyName"
              label="公司名称"
              align="center"
            />
            <el-table-column
              prop="registerAddress"
              label="注册地址"
              align="center"
            />
            <el-table-column prop="name" label="姓名" align="center" />
            <el-table-column prop="phone" label="联系方式" align="center" />
            <el-table-column
              prop="legalIdCard"
              label="法人身份证"
              align="center"
            />
            <el-table-column
              prop="contractDate"
              label="合同日期"
              align="center"
            />
            <el-table-column label="附件" align="center" width="120">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="handleAttachment(scope.row)"
                  v-if="
                    scope.row.attachment && scope.row.attachment.trim() !== ''
                  "
                >
                  上传/查看
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleAttachment(scope.row)"
                  v-else
                >
                  上传
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleDownloadAttachment(scope.row)"
                  v-if="
                    scope.row.attachment && scope.row.attachment.trim() !== ''
                  "
                >
                  下载
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="form.id ? '编辑虚拟合同' : '新增虚拟合同'"
      :visible.sync="formVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="120px"
        label-position="right"
      >
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="form.companyName" placeholder="请输入公司名称" />
        </el-form-item>
        <el-form-item label="注册地址" prop="registerAddress">
          <el-input
            v-model="form.registerAddress"
            type="textarea"
            placeholder="请输入注册地址"
          />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系方式" />
        </el-form-item>
        <el-form-item label="法人身份证" prop="legalIdCard">
          <el-input
            v-model="form.legalIdCard"
            placeholder="请输入法人身份证号"
          />
        </el-form-item>
        <el-form-item label="合同日期" prop="contractDate">
          <el-date-picker
            v-model="form.contractDate"
            type="month"
            placeholder="选择合同月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
          />
        </el-form-item>
        <el-form-item label="附件">
          <el-button type="text" @click="handleAttachment(form)">
            {{
              form.attachment && form.attachment.trim() !== ""
                ? "更换附件"
                : "上传附件"
            }}
          </el-button>
          <span
            v-if="form.attachment && form.attachment.trim() !== ''"
            class="attachment-tip"
          >
            已上传：{{ getFileName(form.attachment) }}
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="删除虚拟合同"
      :visible.sync="deleteVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 0; text-align: center" v-if="!isBatchDelete">
        <i class="el-icon-warning" style="color: #e6a23c; font-size: 24px"></i>
        <p style="margin-top: 10px">确定要删除该虚拟合同吗？</p>
        <p style="color: #999; font-size: 12px">删除后将无法恢复，请谨慎操作</p>
      </div>
      <div style="padding: 20px 0; text-align: center" v-if="isBatchDelete">
        <i class="el-icon-warning" style="color: #e6a23c; font-size: 24px"></i>
        <p style="margin-top: 10px">
          确定要批量删除选中的{{ selectedIds.length }}条合同吗？
        </p>
        <p style="color: #999; font-size: 12px">删除后将无法恢复，请谨慎操作</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">确定删除</el-button>
      </div>
    </el-dialog>

    <!-- 附件上传弹窗（替换为示例风格） -->
    <el-dialog
      title="上传合同附件"
      :visible.sync="attachmentVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-upload
        class="upload-demo"
        drag
        action="/callComponent/upload/uploadFile/uploadImage"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
        :limit="1"
        name="uploadFile"
        :data="uploadExtraParams"
        :file-list="fileList"
        :on-success="handleUploadSuccess"
        :on-remove="handleRemove"
        :auto-upload="true"
        :on-exceed="handleExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          支持 PDF, Word, Excel, PPT (单个文件最大 10MB)
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="attachmentVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- Excel导入弹窗（保留，如需移除可自行注释） -->
    <el-dialog
      title="导入虚拟合同"
      :visible.sync="importVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-upload
        class="upload-demo"
        drag
        action="/virtualContract.importVirtualContractCmd"
        accept=".xlsx,.xls"
        :limit="1"
        name="file"
        :data="{ communityId: communityId }"
        :on-success="handleImportSuccess"
        :auto-upload="false"
        :on-exceed="handleExceed"
        ref="importUpload"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将Excel文件拖到此处，或<em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          支持 .xls .xlsx 格式 (单个文件最大 10MB)
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importVisible = false">取消</el-button>
        <el-button type="primary" @click="submitImport">确定导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getContractList,
  addContract,
  editContract,
  deleteContract,
  batchDeleteContract,
  batchDownloadAttachment,
} from "@/api/contract/virtualContractApi";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "VirtualContractManageList",
  data() {
    return {
      loading: false,
      // 搜索表单
      searchForm: {
        companyName: "",
        name: "",
        phone: "",
        contractDate: "",
      },
      // 表格数据
      tableData: [],
      // 分页参数
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      // 选中的ID列表（批量操作）
      selectedIds: [],
      // 表单弹窗相关
      formVisible: false,
      form: {
        id: "",
        companyName: "",
        registerAddress: "",
        name: "",
        phone: "",
        legalIdCard: "",
        contractDate: "",
        attachment: "", // 修改：直接存储文件路径，初始为空字符串
      },
      // 表单校验规则
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        contractDate: [
          { required: true, message: "请选择合同日期", trigger: "change" },
        ],
      },
      // 删除弹窗相关
      deleteVisible: false,
      deleteRow: {},
      isBatchDelete: false,
      // 附件上传相关（匹配示例风格）
      attachmentVisible: false,
      attachmentRow: {}, // 暂存当前操作的行/表单对象
      fileList: [],
      uploadExtraParams: {
        communityId: "",
        contractId: "", // 新增合同ID参数
      },
      // 导入相关
      importVisible: false,
      communityId: "",
      progress: 0, // 新增进度参数，匹配示例风格
    };
  },
  created() {
    this.communityId = getCommunityId() || "";
    this.uploadExtraParams.communityId = this.communityId; // 初始化上传参数
    this.getList();
  },
  methods: {
    /**
     * 获取附件文件名（修改：直接解析文件路径）
     */
    getFileName(filePath) {
      if (!filePath || filePath.trim() === "") {
        return "附件文件";
      }
      // 直接从文件路径截取文件名
      return filePath.split("/").pop() || "附件文件";
    },

    /**
     * 获取列表数据（适配java110接口）
     */
    async getList() {
      try {
        this.loading = true;
        const params = {
          page: this.page.current,
          row: this.page.size,
          companyName: this.searchForm.companyName,
          name: this.searchForm.name,
          phone: this.searchForm.phone,
          contractDate: this.searchForm.contractDate,
          communityId: this.communityId,
        };
        // 调用java110风格的接口
        const res = await getContractList(params);
        if (res && res.code === 0) {
          this.tableData = res.data || [];
          this.page.total = res.total || 0;
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error(res.msg || "获取列表失败");
        }
      } catch (error) {
        console.error("获取虚拟合同列表失败:", error);
        this.$message.error("获取虚拟合同列表失败，请稍后重试");
        this.tableData = [];
        this.page.total = 0;
      } finally {
        this.loading = false;
      }
    },

    /**
     * 搜索
     */
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },

    /**
     * 重置
     */
    handleReset() {
      this.searchForm = {
        companyName: "",
        name: "",
        phone: "",
        contractDate: "",
      };
      this.handleSearch();
    },

    /**
     * 分页大小改变
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },

    /**
     * 分页页码改变
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },

    /**
     * 表格选择事件
     */
    handleSelectionChange(val) {
      this.selectedIds = val.map((item) => item.id);
    },

    /**
     * 新增
     */
    handleAdd() {
      this.form = {
        id: "",
        companyName: "",
        registerAddress: "",
        name: "",
        phone: "",
        legalIdCard: "",
        contractDate: "",
        attachment: "", // 初始为空字符串
        communityId: this.communityId,
      };
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    /**
     * 编辑
     */
    handleEdit(row) {
      this.form = { ...row, communityId: this.communityId };
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    /**
     * 提交表单（新增/编辑）
     */
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();

        // 补充社区ID（必填）
        const submitForm = {
          ...this.form,
          communityId: this.communityId,
        };

        let res;
        if (submitForm.id) {
          // 编辑
          res = await editContract(submitForm);
        } else {
          // 新增
          res = await addContract(submitForm);
        }

        if (res && res.code === 0) {
          this.$message.success(
            submitForm.id ? "编辑虚拟合同成功" : "新增虚拟合同成功",
          );
          this.formVisible = false;
          this.getList();
        } else {
          this.$message.error(
            res.msg ||
              (submitForm.id ? "编辑虚拟合同失败" : "新增虚拟合同失败"),
          );
        }
      } catch (error) {
        if (error !== false) {
          // 排除校验失败的情况
          console.error("提交虚拟合同失败:", error);
          this.$message.error(
            this.form.id ? "编辑虚拟合同失败" : "新增虚拟合同失败",
          );
        }
      }
    },

    /**
     * 打开删除确认框（单个）
     */
    handleDelete(row) {
      this.deleteRow = row;
      this.isBatchDelete = false;
      this.deleteVisible = true;
    },

    /**
     * 批量删除
     */
    handleBatchDelete() {
      this.isBatchDelete = true;
      this.deleteVisible = true;
    },

    /**
     * 确认删除
     */
    async confirmDelete() {
      try {
        let res;
        if (this.isBatchDelete) {
          // 批量删除
          res = await batchDeleteContract(this.selectedIds);
        } else {
          // 单个删除
          res = await deleteContract({
            id: this.deleteRow.id,
            communityId: this.communityId,
          });
        }

        if (res && res.code === 0) {
          this.$message.success(
            this.isBatchDelete ? "批量删除成功" : "删除虚拟合同成功",
          );
          this.deleteVisible = false;
          this.getList();
          this.selectedIds = []; // 清空选中
        } else {
          this.$message.error(
            res.msg ||
              (this.isBatchDelete ? "批量删除失败" : "删除虚拟合同失败"),
          );
        }
      } catch (error) {
        console.error("删除虚拟合同失败:", error);
        this.$message.error(
          this.isBatchDelete ? "批量删除失败" : "删除虚拟合同失败，请稍后重试",
        );
      }
    },

    /**
     * 打开附件上传弹窗（适配新的上传参数）
     */
    handleAttachment(row) {
      this.attachmentRow = row; // 暂存当前操作的行/表单对象
      // 更新上传参数，匹配示例风格
      this.uploadExtraParams.contractId = row.id || "";
      this.fileList = [];

      // 初始化已上传的文件（修改：直接使用文件路径）
      if (row.attachment && row.attachment.trim() !== "") {
        this.fileList = [
          {
            name: this.getFileName(row.attachment),
            url: row.attachment,
            status: "success",
          },
        ];
      }

      this.attachmentVisible = true;
    },

    /**
     * 附件上传成功回调（核心修改：直接存储文件路径）
     */
    handleUploadSuccess(response, file) {
      try {
        // 适配文件上传返回格式，获取文件地址
        const fileUrl =
          response.url || (response.data && response.data.url) || "";
        if (!fileUrl) {
          this.$message.error("文件上传失败：未获取到文件地址");
          return;
        }

        file.url = fileUrl;
        this.fileList = [file];

        // 判断是编辑/新增状态，将文件路径存入对应对象
        if (this.attachmentRow.id) {
          // 编辑已有合同：更新行对象和表单对象的附件字段
          this.attachmentRow.attachment = fileUrl;
          // 如果当前是弹窗编辑状态，同步更新表单
          if (this.form.id === this.attachmentRow.id) {
            this.form.attachment = fileUrl;
          }
        } else {
          // 新增合同：直接更新表单的附件字段
          this.form.attachment = fileUrl;
        }

        this.$message.success("附件上传成功");
        this.attachmentVisible = false;
      } catch (error) {
        console.error("处理附件上传结果失败:", error);
        this.$message.error("附件上传失败，请稍后重试");
      }
    },

    /**
     * 移除已上传文件（核心修改：清空文件路径）
     */
    handleRemove(file, fileList) {
      this.fileList = fileList;
      const emptyAttachment = "";

      try {
        // 更新对应对象的附件字段
        if (this.attachmentRow.id) {
          // 已有合同
          this.attachmentRow.attachment = emptyAttachment;
          // 如果当前是弹窗编辑状态，同步更新表单
          if (this.form.id === this.attachmentRow.id) {
            this.form.attachment = emptyAttachment;
          }
        } else {
          // 新增合同
          this.form.attachment = emptyAttachment;
        }

        this.$message.success("附件已移除");
      } catch (error) {
        console.error("移除附件失败:", error);
        this.$message.error("移除附件失败，请稍后重试");
      }
    },

    /**
     * 文件超出数量限制
     */
    handleExceed(files) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`,
      );
    },

    /**
     * 下载单个附件（核心修改：直接使用文件路径下载）
     */
    handleDownloadAttachment(row) {
      try {
        if (!row.attachment || row.attachment.trim() === "") {
          this.$message.warning("暂无附件可下载");
          return;
        }

        // 直接使用文件路径创建下载链接
        const link = document.createElement("a");
        // 处理相对路径/绝对路径
        link.href = row.attachment.startsWith("http")
          ? row.attachment
          : window.location.origin + row.attachment;
        link.download = this.getFileName(row.attachment);
        // 解决浏览器兼容问题
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success("附件下载成功");
      } catch (error) {
        console.error("下载附件失败:", error);
        this.$message.error("附件下载失败，请稍后重试");
      }
    },

    /**
     * 批量下载附件
     */
    async handleBatchDownload() {
      try {
        const res = await batchDownloadAttachment({
          ids: this.selectedIds,
          communityId: this.communityId,
        });

        // 处理二进制流下载
        const blob = new Blob([res.data], { type: "application/zip" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `合同附件_${new Date().getTime()}.zip`;
        link.click();
        window.URL.revokeObjectURL(link.href);

        this.$message.success("批量下载附件成功");
      } catch (error) {
        console.error("批量下载附件失败:", error);
        this.$message.error("批量下载附件失败，请稍后重试");
      }
    },

    /**
     * 打开导入弹窗
     */
    handleImport() {
      this.importVisible = true;
      this.$nextTick(() => {
        if (this.$refs.importUpload) {
          this.$refs.importUpload.clearFiles();
        }
      });
    },

    /**
     * 提交导入
     */
    submitImport() {
      if (this.$refs.importUpload) {
        this.$refs.importUpload.submit();
      }
    },

    /**
     * 导入成功处理
     */
    async handleImportSuccess(res) {
      try {
        if (res && res.code === 0) {
          this.$message.success("合同导入成功");
          this.importVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg || "合同导入失败");
        }
      } catch (error) {
        console.error("导入合同失败:", error);
        this.$message.error("合同导入失败，请稍后重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.virtual-contract-manage-container {
  padding: 20px;

  .search-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-card {
    margin-bottom: 20px;
  }

  .dialog-footer {
    text-align: right;
  }

  .attachment-tip {
    margin-left: 10px;
    color: #666;
    font-size: 12px;
  }

  .upload-demo {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
      height: 200px;
      line-height: 200px;
    }
  }

  // 匹配示例的样式
  ::v-deep .el-upload__tip {
    margin-top: 6px;
    font-size: 13px;
    color: #606266;
  }

  ::v-deep .el-form-item__content {
    line-height: 1.2;
  }

  ::v-deep .el-upload-dragger {
    padding: 30px 0;
  }
}
</style>
